import { NewRelicPlusPlugin, NewRelicEventType, EventType, ElementType, EventAction } from '@cof/stratum';

// PRODUCT_NAME is a required export of this file (use your DevNav component name)
const PRODUCT_NAME = 'fs-esign-mfe-staticassets';
const PLUGINS = [NewRelicPlusPlugin()];
// PRODUCT_VERSION is a required export of this file
const PRODUCT_VERSION = '1.2.1';
var TagKey;
(function (TagKey) {
    /**
     * Enumerate keys of tag catalog entries here for easy
     * use and consistent reference across your application.
     *
     * The values of the tag keys can be any string or number
     * value. These keys will not be referenced outside
     * of the application.
     */
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN"] = "PAGE_VIEW_COAF_REFI_ESIGN";
    TagKey["VIEW_E_SIGN"] = "VIEW_E_SIGN";
    TagKey["E_SIGN_PHONE_NUMBER_LINK"] = "E_SIGN_PHONE_NUMBER_LINK";
    TagKey["E_SIGN_DOWNLOAD_MY_CONTRACT"] = "E_SIGN_DOWNLOAD_MY_CONTRACT";
    TagKey["E_SIGN_LSA_CONSENT_CHECKED"] = "E_SIGN_LSA_CONSENT_CHECKED";
    TagKey["E_SIGN_PAYOFF_CONSENT_CHECKED"] = "E_SIGN_PAYOFF_CONSENT_CHECKED";
    TagKey["E_SIGN_SUBMIT_ESIGN_CONTRACT"] = "E_SIGN_SUBMIT_ESIGN_CONTRACT";
    TagKey["E_SIGN_COAPP_CONSENT_SUBMIT"] = "E_SIGN_COAPP_CONSENT_SUBMIT";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_2"] = "PAGE_VIEW_COAF_REFI_ESIGN_2";
    TagKey["ICONIC_CONTRACT_DOWNLOAD_FULL_AGREEMENT"] = "ICONIC_CONTRACT_DOWNLOAD_FULL_AGREEMENT";
    TagKey["ICONIC_CONTRACT_SIGN_AGREEMENT"] = "ICONIC_CONTRACT_SIGN_AGREEMENT";
    TagKey["ICONIC_CONTRACT_DOWNLOAD_LSA_MAILER"] = "ICONIC_CONTRACT_DOWNLOAD_LSA_MAILER";
    TagKey["VIEW_ICONIC_CONTRACT"] = "VIEW_ICONIC_CONTRACT";
    TagKey["ICONIC_CONTRACT_MODAL_LSA_DOWNLOAD_LINK"] = "ICONIC_CONTRACT_MODAL_LSA_DOWNLOAD_LINK";
    TagKey["ICONIC_CONTRACT_ESIGN_CONSENT_MODAL_CLOSED"] = "ICONIC_CONTRACT_ESIGN_CONSENT_MODAL_CLOSED";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_POA_"] = "PAGE_VIEW_COAF_REFI_ESIGN_POA_";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_TITLE_AUTH_"] = "PAGE_VIEW_COAF_REFI_ESIGN_TITLE_AUTH_";
    TagKey["VIEW_POA"] = "VIEW_POA";
    TagKey["VIEW_TITLE_AUTHORIZATION"] = "VIEW_TITLE_AUTHORIZATION";
    TagKey["POA__ESIGN_POWER_OF_ATTORNEY"] = "POA__ESIGN_POWER_OF_ATTORNEY";
    TagKey["POA__REVIEW_FULL_POWER_OF_ATTORNEY"] = "POA__REVIEW_FULL_POWER_OF_ATTORNEY";
    TagKey["POA__SKIP_FOR_NOW_ON_POA"] = "POA__SKIP_FOR_NOW_ON_POA";
    TagKey["TITLE_AUTHORIZATION_ESIGN_TITLE_AUTHORIZATION"] = "TITLE_AUTHORIZATION_ESIGN_TITLE_AUTHORIZATION";
    TagKey["TITLE_AUTHORIZATION_REVIEW_FULL_TITLE_AUTHORIZATION"] = "TITLE_AUTHORIZATION_REVIEW_FULL_TITLE_AUTHORIZATION";
    TagKey["TITLE_AUTHORIZATION_SKIP_FOR_NOW_ON_TITLE_AUTHORIZATION"] = "TITLE_AUTHORIZATION_SKIP_FOR_NOW_ON_TITLE_AUTHORIZATION";
    TagKey["POA_DRIVERS_LICENSE_STATE_SELECTED"] = "POA_DRIVERS_LICENSE_STATE_SELECTED";
    TagKey["POA_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_"] = "POA_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_";
    TagKey["POA_ODOMETER_READING_FIELD_EDITED"] = "POA_ODOMETER_READING_FIELD_EDITED";
    TagKey["POA_VEHICLE_COLOR_FIELD_EDITED"] = "POA_VEHICLE_COLOR_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__LEGAL_FIRST_NAME_FIELD_EDITED"] = "TITLE_AUTHORIZATION__LEGAL_FIRST_NAME_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__LEGAL_MIDDLE_NAME_FIELD_EDITED"] = "TITLE_AUTHORIZATION__LEGAL_MIDDLE_NAME_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__LEGAL_LAST_NAME_FIELD_EDITED"] = "TITLE_AUTHORIZATION__LEGAL_LAST_NAME_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__LEGAL_SUFFIX_FIELD_EDITED"] = "TITLE_AUTHORIZATION__LEGAL_SUFFIX_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__DRIVERS_LICENSE_STATE_SELECTED"] = "TITLE_AUTHORIZATION__DRIVERS_LICENSE_STATE_SELECTED";
    TagKey["TITLE_AUTHORIZATION__DRIVERS_LICENSE_NUMBER_FIELD_EDITED"] = "TITLE_AUTHORIZATION__DRIVERS_LICENSE_NUMBER_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__ODOMETER_READING_FIELD_EDITED"] = "TITLE_AUTHORIZATION__ODOMETER_READING_FIELD_EDITED";
    TagKey["TITLE_AUTHORIZATION__VEHICLE_PURCHASE_DATE_FIELD_EDITED"] = "TITLE_AUTHORIZATION__VEHICLE_PURCHASE_DATE_FIELD_EDITED";
    TagKey["POA_AND_TITLE_AUTHORIZATION_FIELD_ERROR_MESSAGE_DISPLAYED"] = "POA_AND_TITLE_AUTHORIZATION_FIELD_ERROR_MESSAGE_DISPLAYED";
    TagKey["POA_AND_TITLE_AUTHORIZATION_SKIP_FOR_NOW_DISPLAYED"] = "POA_AND_TITLE_AUTHORIZATION_SKIP_FOR_NOW_DISPLAYED";
    TagKey["ICONIC_CONTRACT_WHATS_A_FINANCE_CHARGE"] = "ICONIC_CONTRACT_WHATS_A_FINANCE_CHARGE";
    TagKey["NR_VIEW_COAF_REFI_ESIGN"] = "NR_VIEW_COAF_REFI_ESIGN";
    TagKey["POA__I_AGREE_CLICKED_IN_POA_MODAL"] = "POA__I_AGREE_CLICKED_IN_POA_MODAL";
    TagKey["TITLE_AUTHORIZATION_I_AGREE_CLICKED_IN_TITLE_AUTH_MODAL"] = "TITLE_AUTHORIZATION_I_AGREE_CLICKED_IN_TITLE_AUTH_MODAL";
    TagKey["POA_POWER_OF_ATTORNEY_MODAL_CLOSED"] = "POA_POWER_OF_ATTORNEY_MODAL_CLOSED";
    TagKey["TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_MODAL_CLOSED"] = "TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_MODAL_CLOSED";
    TagKey["CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED"] = "CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED";
    TagKey["POA_ESIGN_API_SUCCESS"] = "POA_ESIGN_API_SUCCESS";
    TagKey["POA_ESIGN_API_FAILED"] = "POA_ESIGN_API_FAILED";
    TagKey["TITLE_AUTHORIZATION_ESIGN_API_SUCCESS"] = "TITLE_AUTHORIZATION_ESIGN_API_SUCCESS";
    TagKey["TITLE_AUTHORIZATION_ESIGN_API_FAILED"] = "TITLE_AUTHORIZATION_ESIGN_API_FAILED";
    TagKey["ETITLE_ETITLE_DETAILS_API_SUCCESSFUL"] = "ETITLE_ETITLE_DETAILS_API_SUCCESSFUL";
    TagKey["ETITLE_ETITLE_DETAILS_API_FAILED"] = "ETITLE_ETITLE_DETAILS_API_FAILED";
    TagKey["POA_POA_DOCUMENT_SUCCESSFULLY_DOWNLOADED"] = "POA_POA_DOCUMENT_SUCCESSFULLY_DOWNLOADED";
    TagKey["POA_POA_DOCUMENT_FAILED_TO_DOWNLOAD"] = "POA_POA_DOCUMENT_FAILED_TO_DOWNLOAD";
    TagKey["TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED"] = "TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED";
    TagKey["TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_FAILED_TO_DOWNLOAD"] = "TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_FAILED_TO_DOWNLOAD";
    TagKey["POA_AND_TITLE_AUTHORIZATION_WHY_TRANSFERRING_YOUR_TITLE_MATTERS_ACCORDION_EXPANDED"] = "POA_AND_TITLE_AUTHORIZATION_WHY_TRANSFERRING_YOUR_TITLE_MATTERS_ACCORDION_EXPANDED";
    TagKey["COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CHECKBOX_SELECTED"] = "COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CHECKBOX_SELECTED";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_3"] = "PAGE_VIEW_COAF_REFI_ESIGN_3";
    TagKey["COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONTRACT_CTA"] = "COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONTRACT_CTA";
    TagKey["COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONSENT_MODAL_CTA"] = "COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONSENT_MODAL_CTA";
    TagKey["ICONIC_CONTRACT_COAPP_ESIGN_CONSENT_SUBMIT"] = "ICONIC_CONTRACT_COAPP_ESIGN_CONSENT_SUBMIT";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_TITLE_APP"] = "PAGE_VIEW_COAF_REFI_ESIGN_TITLE_APP";
    TagKey["VIEW_TITLE_APPLICATION"] = "VIEW_TITLE_APPLICATION";
    TagKey["TITLE_APPLICATION_ESIGN_TITLE_APPLICATION"] = "TITLE_APPLICATION_ESIGN_TITLE_APPLICATION";
    TagKey["TITLE_APPLICATION_REVIEW_FULL_TITLE_APPLICATION"] = "TITLE_APPLICATION_REVIEW_FULL_TITLE_APPLICATION";
    TagKey["TITLE_APPLICATION_SKIP_FOR_NOW_ON_TITLE_APPLICATION"] = "TITLE_APPLICATION_SKIP_FOR_NOW_ON_TITLE_APPLICATION";
    TagKey["TITLE_APPLICATION_DRIVERS_LICENSE_STATE_SELECTED"] = "TITLE_APPLICATION_DRIVERS_LICENSE_STATE_SELECTED";
    TagKey["TITLE_APPLICATION_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_"] = "TITLE_APPLICATION_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_";
    TagKey["TITLE_APPLICATION_I_AGREE_CLICKED_IN_TITLE_APPLICATION_MODAL"] = "TITLE_APPLICATION_I_AGREE_CLICKED_IN_TITLE_APPLICATION_MODAL";
    TagKey["TITLE_APPLICATION_TITLE_APPLICATION_MODAL_CLOSED"] = "TITLE_APPLICATION_TITLE_APPLICATION_MODAL_CLOSED";
    TagKey["TITLE_APPLICATION_ESIGN_API_SUCCESS"] = "TITLE_APPLICATION_ESIGN_API_SUCCESS";
    TagKey["TITLE_APPLICATION_ESIGN_API_FAILED"] = "TITLE_APPLICATION_ESIGN_API_FAILED";
    TagKey["TITLE_APPLICATION_TITLE_APPLICATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED"] = "TITLE_APPLICATION_TITLE_APPLICATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED";
    TagKey["TITLE_APPLICATION_TITLE_APPLICATION_FAILED_TO_DOWNLOAD"] = "TITLE_APPLICATION_TITLE_APPLICATION_FAILED_TO_DOWNLOAD";
    TagKey["POATA_WE_AGREE_CLICKED_IN_POATA_MODAL"] = "POATA_WE_AGREE_CLICKED_IN_POATA_MODAL";
    TagKey["PAGE_VIEW_COAF_REFI_ESIGN_SECURITY_AGREEMENT"] = "PAGE_VIEW_COAF_REFI_ESIGN_SECURITY_AGREEMENT";
    TagKey["VIEW_SECURITY_AGREEMENT"] = "VIEW_SECURITY_AGREEMENT";
    TagKey["SECURITY_AGREEMENT_ESIGN_SECURITY_AGREEMENT"] = "SECURITY_AGREEMENT_ESIGN_SECURITY_AGREEMENT";
    TagKey["SECURITY_AGREEMENT_REVIEW_FULL_SECURITY_AGREEMENT"] = "SECURITY_AGREEMENT_REVIEW_FULL_SECURITY_AGREEMENT";
    TagKey["SECURITY_AGREEMENT_SKIP_FOR_NOW_ON_SECURITY_AGREEMENT"] = "SECURITY_AGREEMENT_SKIP_FOR_NOW_ON_SECURITY_AGREEMENT";
    TagKey["SECURITY_AGREEMENT_I_AGREE_CLICKED_IN_SECURITY_AGREEMENT_MODAL"] = "SECURITY_AGREEMENT_I_AGREE_CLICKED_IN_SECURITY_AGREEMENT_MODAL";
    TagKey["SECURITY_AGREEMENT_SECURITY_AGREEMENT_MODAL_CLOSED"] = "SECURITY_AGREEMENT_SECURITY_AGREEMENT_MODAL_CLOSED";
    TagKey["SECURITY_AGREEMENT_ESIGN_API_SUCCESS"] = "SECURITY_AGREEMENT_ESIGN_API_SUCCESS";
    TagKey["SECURITY_AGREEMENT_ESIGN_API_FAILED"] = "SECURITY_AGREEMENT_ESIGN_API_FAILED";
    TagKey["SECURITY_AGREEMENT_SECURITY_AGREEMENT_DOCUMENT_SUCCESSFULLY_DOWNLOADED"] = "SECURITY_AGREEMENT_SECURITY_AGREEMENT_DOCUMENT_SUCCESSFULLY_DOWNLOADED";
    TagKey["SECURITY_AGREEMENT_SECURITY_AGREEMENT_FAILED_TO_DOWNLOAD"] = "SECURITY_AGREEMENT_SECURITY_AGREEMENT_FAILED_TO_DOWNLOAD";
    TagKey["TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_STATE_SELECTED"] = "TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_STATE_SELECTED";
    TagKey["TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_NUMBER_FIELD_EDITED"] = "TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_NUMBER_FIELD_EDITED";
    TagKey["ESIGN_SLIDER_START"] = "ESIGN_SLIDER_START";
    TagKey["ESIGN_SLIDER_COMPLETE"] = "ESIGN_SLIDER_COMPLETE";
})(TagKey || (TagKey = {}));
// TAG_CATALOG is a required export of this file
// @ts-ignore
const TAG_CATALOG = {
    /**
     * Add TagCatalog entries here. Best practice
     * is to use enumerated values for the tag keys.
     *
     * For properties with values of a specific type (like eventType),
     * export the corresponding type from the @cof/stratum package.
     */
    [TagKey.NR_VIEW_COAF_REFI_ESIGN]: {
        eventType: NewRelicEventType.EVENT,
        tagDescription: 'Esign Viewed',
        tagId: 100,
        name: 'User viewed Esign page',
        message: ''
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Contract Page Viewed',
        tagId: 6001,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_E_SIGN]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Contract PDF Viewer Shown',
        tagId: 6002,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
    },
    [TagKey.E_SIGN_PHONE_NUMBER_LINK]: {
        eventType: EventType.UI,
        tagDescription: "User clicks on the 'phone number' link within the \"What's a Finance Charge\" box",
        tagId: 6003,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
        tagName: 'phone number link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.E_SIGN_DOWNLOAD_MY_CONTRACT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Download My Contract" button at the bottom of the Contract Page',
        tagId: 6004,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
        tagName: 'download my contract',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.E_SIGN_LSA_CONSENT_CHECKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on the "Loan Service Agreement (LSA)" consent checkbox',
        tagId: 6005,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
        tagName: 'lsa consent checked',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.E_SIGN_PAYOFF_CONSENT_CHECKED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on the "Authorize COAF to payoff current LH" consent checkbox',
        tagId: 6006,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
        tagName: 'payoff consent checked',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.E_SIGN_SUBMIT_ESIGN_CONTRACT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "ESign My Contract" button at the bottom of the ESign page',
        tagId: 6007,
        rules: {
            applicationId: true,
        },
        featureName: 'E-sign',
        tagName: 'submit esign contract',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_2]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'Land on Iconic E-sign page',
        tagId: 6008,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.ICONIC_CONTRACT_DOWNLOAD_FULL_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Download full agreement" in the middle of the iconic contract page',
        tagId: 6009,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'download full agreement',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_CONTRACT_SIGN_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Sign Agreement" button at the bottom of the iconic contract page',
        tagId: 6010,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'sign agreement',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_CONTRACT_DOWNLOAD_LSA_MAILER]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "download this mailable version" link at the bottom of the contract page',
        tagId: 6011,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'download lsa mailer',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.VIEW_ICONIC_CONTRACT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'Iconic eSign Consent Modal Viewed',
        tagId: 6012,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
    },
    [TagKey.ICONIC_CONTRACT_MODAL_LSA_DOWNLOAD_LINK]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "Loan & Security Agreement" link in the iconic contract consent modal',
        tagId: 6013,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'modal lsa download link',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_CONTRACT_ESIGN_CONSENT_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "X" in the contract consent modal',
        tagId: 6014,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'esign consent modal closed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_POA_]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'eSign Power of Attorney Inline Page',
        tagId: 6015,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: 'poa ',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_TITLE_AUTH_]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'eSign Title Authorization Inline Page',
        tagId: 6016,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: 'title auth ',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_POA]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'eSign Power of Attorney Modal opened',
        tagId: 6017,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
    },
    [TagKey.VIEW_TITLE_AUTHORIZATION]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'eSign Title Authorization Modal opened',
        tagId: 6018,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
    },
    [TagKey.POA__ESIGN_POWER_OF_ATTORNEY]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'E-sign Power of Attorney' button (values are state)",
        tagId: 6019,
        rules: {
            applicationId: true,
        },
        featureName: 'POA ',
        tagName: 'esign power of attorney',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.POA__REVIEW_FULL_POWER_OF_ATTORNEY]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Review full Power of Attorney' link (values are state)",
        tagId: 6020,
        rules: {
            applicationId: true,
        },
        featureName: 'POA ',
        tagName: 'review full power of attorney',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.POA__SKIP_FOR_NOW_ON_POA]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Skip for now' on POA inline page (values are state)",
        tagId: 6021,
        rules: {
            applicationId: true,
        },
        featureName: 'POA ',
        tagName: 'skip for now on poa',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION_ESIGN_TITLE_AUTHORIZATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'E-sign Title Authorization' button (values are state)",
        tagId: 6022,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'esign title authorization',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION_REVIEW_FULL_TITLE_AUTHORIZATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Review full Title Authorization' link (values are state)",
        tagId: 6023,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'review full title authorization',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION_SKIP_FOR_NOW_ON_TITLE_AUTHORIZATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Skip for now' on Title Authorization inline page (values are state)",
        tagId: 6024,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'skip for now on title authorization',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.POA_DRIVERS_LICENSE_STATE_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: "User clicks dropdown and selects state for driver's license state field (values are state)",
        tagId: 6025,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'drivers license state selected',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}',
    },
    [TagKey.POA_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_]: {
        eventType: EventType.UI,
        tagDescription: "User edits driver's license number field (values are state)",
        tagId: 6026,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'drivers license number field edited ',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.POA_ODOMETER_READING_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits odometer reading (values are state)',
        tagId: 6027,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'odometer reading field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.POA_VEHICLE_COLOR_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits vehicle color field (values are state)',
        tagId: 6028,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'vehicle color field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__LEGAL_FIRST_NAME_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits legal first name field (values are state)',
        tagId: 6029,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'legal first name field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__LEGAL_MIDDLE_NAME_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits legal middle name field (values are state)',
        tagId: 6030,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'legal middle name field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__LEGAL_LAST_NAME_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits legal last name field (values are state)',
        tagId: 6031,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'legal last name field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__LEGAL_SUFFIX_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits legal suffix field (values are state)',
        tagId: 6032,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'legal suffix field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__DRIVERS_LICENSE_STATE_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: "User clicks dropdown and selects state for driver's license state field (values are state)",
        tagId: 6033,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'drivers license state selected',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__DRIVERS_LICENSE_NUMBER_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: "User edits driver's license number field (values are state)",
        tagId: 6034,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'drivers license number field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__ODOMETER_READING_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits odometer reading (values are state)',
        tagId: 6035,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'odometer reading field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_AUTHORIZATION__VEHICLE_PURCHASE_DATE_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: 'User edits vehicle purchase date (values are state)',
        tagId: 6036,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization ',
        tagName: 'vehicle purchase date field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.POA_AND_TITLE_AUTHORIZATION_FIELD_ERROR_MESSAGE_DISPLAYED]: {
        eventType: EventType.UI,
        tagDescription: 'User inputs invalid entry resulting in error messages displayed for field inputs (Values are state and field)',
        tagId: 6037,
        rules: {
            applicationId: true,
        },
        featureName: 'POA and Title Authorization',
        tagName: 'field error message displayed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
        value: '${value}',
    },
    [TagKey.POA_AND_TITLE_AUTHORIZATION_SKIP_FOR_NOW_DISPLAYED]: {
        eventType: EventType.UI,
        tagDescription: 'Skip for now button displayed (values are state)',
        tagId: 6038,
        rules: {
            applicationId: true,
        },
        featureName: 'POA and Title Authorization',
        tagName: 'skip for now displayed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
        value: '${value}',
    },
    [TagKey.ICONIC_CONTRACT_WHATS_A_FINANCE_CHARGE]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "What\'s a finance charge?" box under the TILA boxes on the iconic contract page',
        tagId: 6039,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'whats a finance charge',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.POA__I_AGREE_CLICKED_IN_POA_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" on eSign Power of attorney modal',
        tagId: 6040,
        featureName: 'POA ',
        tagName: 'i agree clicked in poa modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.TITLE_AUTHORIZATION_I_AGREE_CLICKED_IN_TITLE_AUTH_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" on eSign title authorization modal',
        tagId: 6041,
        featureName: 'Title Authorization',
        tagName: 'i agree clicked in title auth modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.POA_POWER_OF_ATTORNEY_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "X" in the power of attorney modal',
        tagId: 6042,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'power of attorney modal closed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "X" in the title authorization modal',
        tagId: 6043,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'title authorization modal closed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.CUSTOMER_PROFILE_CUSTOMER_PROFILE_DOC_GENERATED]: {
        eventType: EventType.UI,
        tagDescription: 'System generates a customer profile document',
        tagId: 6044,
        rules: {
            applicationId: true,
        },
        featureName: 'Customer Profile',
        tagName: 'customer profile doc generated',
        elementType: ElementType.SEARCH,
        action: EventAction.SUBMIT,
    },
    [TagKey.POA_ESIGN_API_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'API Successfully submitted to eSign Power of Attorney',
        tagId: 6045,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'esign api success',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.POA_ESIGN_API_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'API Failed to submit to esign Power of Attorney',
        tagId: 6046,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'esign api failed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_AUTHORIZATION_ESIGN_API_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'API Successfully submitted to esign Title Authorization',
        tagId: 6047,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'esign api success',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_AUTHORIZATION_ESIGN_API_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'API Failed to submit to esign Title Authorizaiton',
        tagId: 6048,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'esign api failed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.ETITLE_ETITLE_DETAILS_API_SUCCESSFUL]: {
        eventType: EventType.UI,
        tagDescription: 'Successfully retrieved eTitle Document Details',
        tagId: 6049,
        rules: {
            applicationId: true,
        },
        featureName: 'ETitle',
        tagName: 'etitle details api successful',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.ETITLE_ETITLE_DETAILS_API_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'Failed to retrieve eTitle Document Details',
        tagId: 6050,
        rules: {
            applicationId: true,
        },
        featureName: 'ETitle',
        tagName: 'etitle details api failed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.POA_POA_DOCUMENT_SUCCESSFULLY_DOWNLOADED]: {
        eventType: EventType.UI,
        tagDescription: 'Successfully downloaded Power of Attorney',
        tagId: 6051,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'poa document successfully downloaded',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.POA_POA_DOCUMENT_FAILED_TO_DOWNLOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Failed to download Power of Attorney',
        tagId: 6052,
        rules: {
            applicationId: true,
        },
        featureName: 'POA',
        tagName: 'poa document failed to download',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED]: {
        eventType: EventType.UI,
        tagDescription: 'Successfully downloaded Title Authorization',
        tagId: 6053,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'title authorization document successfully downloaded',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_AUTHORIZATION_TITLE_AUTHORIZATION_DOCUMENT_FAILED_TO_DOWNLOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Failed to download Title Authorization',
        tagId: 6054,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Authorization',
        tagName: 'title authorization document failed to download',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.POA_AND_TITLE_AUTHORIZATION_WHY_TRANSFERRING_YOUR_TITLE_MATTERS_ACCORDION_EXPANDED]: {
        eventType: EventType.UI,
        tagDescription: 'User expands "Why transferring your title matters" accordion',
        tagId: 6055,
        rules: {
            applicationId: true,
        },
        featureName: 'POA and Title Authorization',
        tagName: 'why transferring your title matters accordion expanded',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}',
    },
    [TagKey.COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CHECKBOX_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: 'User Clicks the Checkbox to consent to eSign and Hard Pull',
        tagId: 6056,
        rules: {
            applicationId: true,
        },
        featureName: 'Combined HP and Contract',
        tagName: 'combined eSign and Hard Pull checkbox selected',
        elementType: ElementType.CHECKBOX,
        action: EventAction.CHECK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_3]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'eSign Error page Combined HP and Contract',
        tagId: 6057,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: '',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONTRACT_CTA]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "continue to eSign and creditpull" CTA on the Contract page',
        tagId: 6058,
        rules: {
            applicationId: true,
        },
        featureName: 'Combined HP and Contract',
        tagName: 'combined eSign and Hard Pull contract CTA',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.COMBINED_HP_AND_CONTRACT_COMBINED_ESIGN_AND_HARD_PULL_CONSENT_MODAL_CTA]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "Agree and Submit" CTA on the eSign consent modal',
        tagId: 6059,
        rules: {
            applicationId: true,
        },
        featureName: 'Combined HP and Contract',
        tagName: 'combined eSign and Hard Pull consent modal CTA',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ICONIC_CONTRACT_COAPP_ESIGN_CONSENT_SUBMIT]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "We agree" in the CoApp esign consent modal- initating esign',
        tagId: 6060,
        rules: {
            applicationId: true,
        },
        featureName: 'Iconic Contract',
        tagName: 'CoApp esign consent submit',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_TITLE_APP]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'eSign Title Application Inline Page',
        tagId: 6061,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: 'title app',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_TITLE_APPLICATION]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'eSign Title Application Modal opened',
        tagId: 6062,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
    },
    [TagKey.TITLE_APPLICATION_ESIGN_TITLE_APPLICATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'E-sign Title Application' button (values are state)",
        tagId: 6063,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'esign title application',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_REVIEW_FULL_TITLE_APPLICATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Review full Title Application' link (values are state)",
        tagId: 6064,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'review full title application',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_SKIP_FOR_NOW_ON_TITLE_APPLICATION]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Skip for now' on Title Application inline page (values are state)",
        tagId: 6065,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'skip for now on title application',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_DRIVERS_LICENSE_STATE_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: "User clicks dropdown and selects state for driver's license state field (values are state)",
        tagId: 6066,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'drivers license state selected',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_DRIVERS_LICENSE_NUMBER_FIELD_EDITED_]: {
        eventType: EventType.UI,
        tagDescription: "User edits driver's license number field (values are state)",
        tagId: 6067,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'drivers license number field edited ',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_I_AGREE_CLICKED_IN_TITLE_APPLICATION_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" on eSign Title Application modal',
        tagId: 6068,
        featureName: 'Title Application',
        tagName: 'i agree clicked in title application modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.TITLE_APPLICATION_TITLE_APPLICATION_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "X" in the Title Application modal',
        tagId: 6069,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'title application modal closed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.TITLE_APPLICATION_ESIGN_API_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'API Successfully submitted to eSign Title Application',
        tagId: 6070,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'esign api success',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_APPLICATION_ESIGN_API_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'API Failed to submit to esign Title Application',
        tagId: 6071,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'esign api failed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_APPLICATION_TITLE_APPLICATION_DOCUMENT_SUCCESSFULLY_DOWNLOADED]: {
        eventType: EventType.UI,
        tagDescription: 'Successfully downloaded Title Application',
        tagId: 6072,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'title application document successfully downloaded',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_APPLICATION_TITLE_APPLICATION_FAILED_TO_DOWNLOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Failed to download Title Application',
        tagId: 6073,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'title application failed to download',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.POATA_WE_AGREE_CLICKED_IN_POATA_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "We agree" on eSign POATA modal',
        tagId: 6074,
        rules: {
            applicationId: true,
        },
        featureName: 'POATA',
        tagName: 'we agree clicked in poata modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.PAGE_VIEW_COAF_REFI_ESIGN_SECURITY_AGREEMENT]: {
        eventType: EventType.PAGE_VIEW,
        tagDescription: 'eSign Security Agreement Inline Page',
        tagId: 6075,
        rules: {
            applicationId: true,
        },
        taxonomy: {
            level1: 'coaf',
            level2: 'refi',
            level3: 'esign',
            level4: 'security agreement',
            level5: '',
            country: 'us',
            language: 'english',
            system: 'coaf-auto-refinance',
        },
    },
    [TagKey.VIEW_SECURITY_AGREEMENT]: {
        eventType: EventType.SCREEN_VIEW,
        tagDescription: 'eSign Security Agreement Modal opened',
        tagId: 6076,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
    },
    [TagKey.SECURITY_AGREEMENT_ESIGN_SECURITY_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'E-sign Security Agreement' button (values are state)",
        tagId: 6077,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'esign security agreement',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SECURITY_AGREEMENT_REVIEW_FULL_SECURITY_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Review full Security Agreement' link (values are state)",
        tagId: 6078,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'review full security agreement',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SECURITY_AGREEMENT_SKIP_FOR_NOW_ON_SECURITY_AGREEMENT]: {
        eventType: EventType.UI,
        tagDescription: "User clicks 'Skip for now' on Security Agreement inline page (values are state)",
        tagId: 6079,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'skip for now on security agreement',
        elementType: ElementType.LINK,
        action: EventAction.CLICK,
        value: '${value}',
    },
    [TagKey.SECURITY_AGREEMENT_I_AGREE_CLICKED_IN_SECURITY_AGREEMENT_MODAL]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks on "I agree" on eSign Security Agreement modal',
        tagId: 6080,
        featureName: 'Security Agreement',
        tagName: 'i agree clicked in security agreement modal',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.SECURITY_AGREEMENT_SECURITY_AGREEMENT_MODAL_CLOSED]: {
        eventType: EventType.UI,
        tagDescription: 'User clicks "X" in the Security Agreement modal',
        tagId: 6081,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'security agreement modal closed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.SECURITY_AGREEMENT_ESIGN_API_SUCCESS]: {
        eventType: EventType.UI,
        tagDescription: 'API Successfully submitted to eSign Security Agreement',
        tagId: 6082,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'esign api success',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_AGREEMENT_ESIGN_API_FAILED]: {
        eventType: EventType.UI,
        tagDescription: 'API Failed to submit to esign Security Agreement',
        tagId: 6083,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'esign api failed',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_AGREEMENT_SECURITY_AGREEMENT_DOCUMENT_SUCCESSFULLY_DOWNLOADED]: {
        eventType: EventType.UI,
        tagDescription: 'Successfully downloaded Security Agreement',
        tagId: 6084,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'security agreement document successfully downloaded',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.SECURITY_AGREEMENT_SECURITY_AGREEMENT_FAILED_TO_DOWNLOAD]: {
        eventType: EventType.UI,
        tagDescription: 'Failed to download Security Agreement',
        tagId: 6085,
        rules: {
            applicationId: true,
        },
        featureName: 'Security Agreement',
        tagName: 'security agreement failed to download',
        elementType: ElementType.HTML_ELEMENT,
        action: EventAction.LOAD,
    },
    [TagKey.TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_STATE_SELECTED]: {
        eventType: EventType.UI,
        tagDescription: "User clicks dropdown and selects state for co-borrower driver's license state field (values are state)",
        tagId: 6086,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'co-borrower drivers license state selected',
        elementType: ElementType.DROPDOWN,
        action: EventAction.SELECT,
        value: '${value}',
    },
    [TagKey.TITLE_APPLICATION_CO_BORROWER_DRIVERS_LICENSE_NUMBER_FIELD_EDITED]: {
        eventType: EventType.UI,
        tagDescription: "User edits co-borrower driver's license number field (values are state)",
        tagId: 6087,
        rules: {
            applicationId: true,
        },
        featureName: 'Title Application',
        tagName: 'co-borrower drivers license number field edited',
        elementType: ElementType.TEXTINPUT,
        action: EventAction.BLUR,
        value: '${value}',
    },
    [TagKey.ESIGN_SLIDER_START]: {
        eventType: EventType.UI,
        tagDescription: "User starts sliding the eSign slider",
        tagId: 6088,
        rules: {
            applicationId: true,
        },
        featureName: 'Esign Slider',
        tagName: 'esign slider start',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
    [TagKey.ESIGN_SLIDER_COMPLETE]: {
        eventType: EventType.UI,
        tagDescription: "User stops sliding the eSign slider",
        tagId: 6089,
        rules: {
            applicationId: true,
        },
        featureName: 'Esign Slider',
        tagName: 'esign slider completed',
        elementType: ElementType.BUTTON,
        action: EventAction.CLICK,
    },
};

export { PLUGINS, PRODUCT_NAME, PRODUCT_VERSION, TAG_CATALOG, TagKey };
